import { Direction } from '@material-ui/core';
import Card from '@material-ui/core/Card';
import { Col, Row } from 'reactstrap';
import styled, { css } from 'styled-components';

export type flexRowProps = {
  direction?: Direction;
};

export type DirectionProps = {
  direction?: Direction;
};

//Holds the Button container special props
export type ButtonContainerProps = {
  height?: string;
  width?: string;
  marginTop?: string;
  marginBottom?: string;
  padding?: string;
};

export const flexRow = css<flexRowProps>`
  display: flex;
  flex-direction: row;
  direction: ${(props): Direction => props.direction};
`;

export const StyledButtonContainer = styled.div<ButtonContainerProps>`
  .splitButtonStyle {
    border-bottom-left-radius: 10px;
    border-top-left-radius: 10px;
    min-width: 40px;
    text-transform: capitalize;
    color: white;
    background-color: #1299ff;
    height: ${(props): string => `${props.height}px`};
    width: ${(props): string => `${props.width}px`};
    margin-top: ${(props): string => `${props.marginTop}px`};
    margin-bottom: ${(props): string => `${props.marginBottom}px`};
    padding: ${(props): string => `${props.padding}px`};

    &:hover {
      background: #1289ff;
    }
  }

  .splitButtonSelectStyle {
    border-bottom-right-radius: 10px;
    border-top-right-radius: 10px;
    border-bottom-left-radius: 0px;
    border-top-left-radius: 0px;
    min-width: 40px;
    text-transform: capitalize;
    color: white;
    background-color: #1299ff;
    margin-top: ${(props): string => `${props.marginTop}px`};
    margin-bottom: ${(props): string => `${props.marginBottom}px`};
    padding: ${(props): string => `${props.padding}px`};
    box-shadow: 0px 3px 1px -2px rgb(0 0 0 / 20%), 0px 2px 2px 0px rgb(0 0 0 / 14%),
      0px 1px 5px 0px rgb(0 0 0 / 12%);
    margin-left: -2px !important;
    border-color: #1299ff;

    &.show > .btn-success.dropdown-toggle {
      color: white;
      background-color: #1299ff;
      border-color: #1299ff;
    }

    &:hover {
      background: #1289ff;
    }
  }

  .actionButtonStyle {
    min-width: 40px;
    //min-height: 50px;
    text-transform: capitalize;
    border-radius: 10px;
    color: white;
    // color: #656565;
    background-color: #1299ff;
    // background-color: #f2f2f5;
    height: ${(props): string => `${props.height}px`};
    width: ${(props): string => `${props.width}px`};
    margin-top: ${(props): string => `${props.marginTop}px`};
    margin-bottom: ${(props): string => `${props.marginBottom}px`};
    padding: ${(props): string => `${props.padding}px`};

    &:disabled {
      background-color: #c8c8c8;
    }

    &:hover {
      background: #1289ff;
    }
  }

  //I'm interested button style in offerings
  .favoriteButtonStyle {
    background-color: whitesmoke;
    color: black;
    font-weight: 600;
    font-size: 16px;
    width: 11rem;
    text-transform: capitalize;

    &:hover {
      background: #fafafa;
    }
  }

  .favoriteButtonMobileStyle {
    width: 100%;
  }
`;

//Style for actions buttons that are in the middle of the card (such as media and portfolio buttons)
export const StyledCenterButton = styled.div`
  font-size: 1rem;
  width: 100%;
  height: 4rem;
  justify-content: center;
  display: flex;
  padding: 1rem;
  background-color: white;
`;

//holds style for the preview button line with title
export const PreviewLine = styled.div`
  display: flex;
  justify-content: space-between;
`;

export const flexColumn = css`
  display: flex;
  flex-direction: column;
`;
export const flexColumnReverse = css`
  display: flex;
  flex-direction: column-reverse;
`;

export const flexColumnRev = css`
  display: flex;
  flex-direction: column-reverse;
`;

export type SpacingProps = {
  spacing?: number | string;
  fontSize?: number;
};

export const Spacing = css<SpacingProps>`
  font-size: ${props => (props.fontSize ? `${props.fontSize}px` : '1rem')};
  > * {
    margin: ${props => props.spacing && `${props.spacing}em`};
  }
`;

export const SpacingRow = css<SpacingProps>`
  > * {
    margin: ${props => props?.spacing && `0 ${props.spacing}rem`};
  }
`;

export const SpacingCol = css<SpacingProps>`
  > * {
    margin: ${props => props?.spacing && `${props.spacing}rem 0`};
  }
`;

export const PrimaryTextColor = css`
  color: #656565;
`;

export const defaultDividerColor = '#e6e6e6';

type VerticalDividerProps = {
  width?: string;
  height?: string;
  color?: string;
  alignSelf?: string;
  divide?: number | string;
  responsiveStyle?: any;
  mobileStyle?: any;
};

export const VerticalDivider = styled.div<VerticalDividerProps>`
  width: ${props => (props.width ? props.width : '2px')};
  height: ${props => props.height};
  min-height: ${props => props.height};
  background-color: ${props => (props.color ? props.color : defaultDividerColor)};
  margin: ${props => `0 ${props.divide ? props.divide : 20}px`};
  align-self: ${props => props.alignSelf};
  @media only screen and (max-width: 768px) {
    ${props => props.responsiveStyle};
    ${props => props.mobileStyle};
  }
`;

type HorizontalDividerProps = {
  width?: string;
  strokeWidth?: number;
  color?: string;
  alignSelf?: string;
  divide?: number | string;
  responsiveStyle?: any;
  mobileStyle?: any;
};

export const HorizontalDivider = styled.div<HorizontalDividerProps>`
  width: ${props => props.width};
  height: ${props => (props.strokeWidth ? `${props.strokeWidth}px` : '2px')};
  background-color: ${props => (props.color ? props.color : defaultDividerColor)};
  margin: ${props =>
    `${
      props.divide
        ? typeof props.divide === 'string'
          ? props.divide
          : `${props.divide}px 0`
        : `1.25em 0`
    }`};
`;
export type StylesType = {
  styles?: any;
  direction?: any;
  height?: string;
  width?: string;
  extraStyle?: any;
  position?: string;
};

//Style for the titles on each card
export const CardTitleStyle = styled.div<StylesType>`
  text-transform: capitalize;
  font-weight: bold;
  font-size: 18px;
  line-height: 1.4375rem;
  color: #656565;
  padding: 10px;
  display: flex;
  ${props => props?.styles};
`;

export const StyledCard = styled(Card)<StylesType>`
  position: relative;
  border: none;
  border-width: 0;
  -webkit-transition: all 0.2s;
  transition: all 0.2s;
  border-radius: 10px;
  overflow: hidden;
  height: ${props => props.height};
  width: ${props => props.width};
  ${props => props.extraStyle};
  /* &::after {
    content: '';
    position: ${props => (props.position ? props.position : 'absolute')};
    bottom: 0;
    left: 0;
    width: 100%;
    height: 3px;
    background: linear-gradient(
      90deg,
      rgba(18, 153, 255, 0.1) 3.64%,
      rgba(102, 51, 255, 0.1) 100%
    );
  } */
  ${props => props?.styles}
`;

export type GridDisplayProps = {
  direction?: Direction;
};

export const GridDisplay = css<GridDisplayProps>`
  display: grid;
  direction: ${props => (props?.direction === 'rtl' ? 'rtl' : 'ltr')};
`;

export const themeColors = {
  primary: '#1299ff', //light blue
  darkBlue: '#3f51b5', //dark blue
  cyan: '#3ebcd4',
  titleGrey: '#656565',
  skeletonBackground: '#f0f0f0',
  skeletonForeground: '#dedede',
  purple: '#7b59de',
  lightPurple: '#F6F2FF',
  documentLinkColor: '#1264a3',
  deleteRed: '#f4433657',
};

export const colors = (color: string): string => {
  const colorsDict = {
    primary: '#1299ff', //light blue
    secondary: '#3E7925',
    completed: '#3f51b5', //dark blue
  };

  if (colorsDict && colorsDict[color]) {
    return colorsDict[color];
  }
  return color;
};

export const NoDataStyle = styled.div`
  font-size: 1.2rem;
  text-transform: capitalize;
  margin: auto;
  text-align: center;
  color: #999999;
`;

//Define a repeating pattern of colors
export const colorsArray = [
  '#2EDDA1',
  '#6C6874',
  '#6D3F5B',
  '#6D3F5B',
  '#59351F',
  '#EC7C26',
  '#3E5F8A',
  '#9E9764',
  '#ffc1bd',
  '#B44C43',
  '#6C6874',
  '#1299FF',
  '#9ba4b3',
  '#8ec773',
  '#613c7d',
  '#a83258',
  '#d6d45c',
  '#2EDD91',
  '#404032',
  '#2EDDA1',
  '#7AC943',
  '#FDA65C',
  '#9C27B0',
  '#F44339',
  '#2E40DD',
  '#E91E63',
  '#6C6874',
  '#ffc1bd',
  '#d4d97c',
  '#6633FF',
  '#1299FF',
  '#9ba4b3',
  '#8ec773',
  '#613c7d',
  '#a83258',
  '#d6d45c',
  '#2EDD91',
  '#404032',
  '#2EDDA1',
  '#7AC943',
  '#FDA65C',
  '#9C27B0',
  '#F44339',
  '#2E40DD',
  '#E91E63',
  '#9C27B0',
  '#ffc1bd',
  '#d4d97c',
  '#6633FF',
  '#1299FF',
  '#9ba4b3',
  '#8ec773',
  '#613c7d',
  '#a83258',
  '#d6d45c',
  '#2EDD91',
  '#404032',
];

export const ScrollBar = css`
  overflow-y: auto;
  /* width */
  &::-webkit-scrollbar {
    width: 6px !important;
    background-color: #f5f5f5 !important;
  }

  /* Track */
  &::-webkit-scrollbar-track {
    box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3) !important;
    border-radius: 10px !important;
    background-color: #c1c1c1 !important;
  }
  /* Handle */
  &::-webkit-scrollbar-thumb {
    border-radius: 10px !important;
    box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3) !important;
    background-color: #acacac !important;
  }

  /* Handle on hover */
  &::-webkit-scrollbar-thumb:hover {
    background-color: #555 !important;
  }
`;

export const oneLineAnd3DotsInEndLongString = css`
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
`;

export const BackgroundCss = css`
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
`;

export const ColStyle = styled(Col)<StylesType>`
  ${props => props?.styles};
  padding: unset;
`;

export const primaryTableBackgroundColor = `#1264a3`;

type primaryTextStyleProps = {
  fontSize?: number;
};

export const primaryTextStyle = css<primaryTextStyleProps>`
  font-weight: 300;
  font-size: ${props => (props && props.fontSize ? `${props.fontSize}px` : `1rem`)};
  line-height: ${props => (props && props.fontSize ? `${props.fontSize + 5}px` : `1.3125rem`)};
  color: #777777;
`;

export type textAlignByDirectionProps = {
  direction?: Direction;
};

export const textAlignByDirection = css<textAlignByDirectionProps>`
  text-align: ${props =>
    props.direction ? (props.direction === 'ltr' ? 'left' : 'right') : 'start'};
`;

export const DIV = styled.div``;

export const RowStyle = styled(Row)`
  ${flexRow};
  justify-content: center;
`;

export type ExpanderStyleProps = {
  fontSize?: number;
  margin?: string;
};

export const ExpanderStyle = styled.i<ExpanderStyleProps>`
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: ${props => (props.fontSize ? props.fontSize : '2.2916666667rem')};
  margin: ${props => (props.margin ? props.margin : '0 8px')};
`;

export const appHeaderHeight = '3.125rem';

export type responsiveFontSizeProps = {
  fontSize: number;
};
export const responsiveFontSize = css<responsiveFontSizeProps>`
  @media only screen and (max-width: 991px) {
    font-size: ${props => `${props.fontSize * 0.7}px`};
  }

  @media only screen and (min-width: 991px) and (max-width: 1500px) {
    font-size: ${props => `${props.fontSize}px`};
  }

  @media only screen and (min-width: 1501px) {
    font-size: ${props => `${props.fontSize * 1.2}px`};
  }
`;

export type FontSizeProps = {
  fontSize: number;
};

export const FontSizeCss = css<FontSizeProps>`
  font-size: ${props => `${props.fontSize}px`};
`;

export const DirectionCss = css<DirectionProps>`
  ${props => props.direction};
`;

export const BreadcrumbsHeaderStyles = css`
  nav {
    ol {
      li {
        color: #000000;
        font-size: 1.25rem;
        line-height: 1.5rem;
        text-transform: uppercase;
        a {
          cursor: pointer;
          font-weight: 300;
          &:hover {
            color: inherit;
          }
        }
        p {
          font-weight: 500;
          font-size: inherit;
          color: inherit;
          line-height: 100%;
        }
      }
    }
  }
`;

export const SpinnerWrapperStyle = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const MaterialButtonIcon = css`
  .MuiIcon-root {
    display: flex;
  }
`;
